// ---------------------------------------------------------------------------
// ozel-alan-duzenleyici.component.ts
//
// "paylaş kutusu" (edit) bağlamında kullanılan, TÜRE GÖRE input gösteren
// hazır Özel Alan editörü. genel-stok-edit, kutuk-stok-edit vb. tüm
// paylaş_kutusu bileşenlerinde tekrar tekrar yazılan "alanEkle/alanSil/
// alanGuncelle" bloklarının yerine geçer.
//
// KULLANIM (bir paylaş_kutusu edit bileşeninde):
//
//   <ozel-alan-duzenleyici
//     [alanlar]="ozelAlanlar()"
//     (alanlarDegisti)="ozelAlanlarKaydet($event)" />
//
//   ozelAlanlarKaydet(yeni: IOzelAlan[]) {
//     const params = this.parametreler();
//     if (!params) return;
//     this.parametreler.set(this.setEkGuncelle(params, ek => { ek.ozelAlanlar = yeni; }));
//     this.CD.detectChanges();
//   }
//
// NOT: Bu bileşen `params.icerik.ek` / üç-kopya-senkron yazma mantığını
// BİLMEZ — kasıtlı olarak. Çıktısı (alanlarDegisti) her zaman TAM yeni
// diziyi verir; deep-clone + senkron yazmayı ebeveyn (setEkGuncelle ile)
// yapar. Böylece bu bileşen her ekranda (genel-stok, kütük-stok, vb.)
// değişmeden yeniden kullanılabilir.
// ---------------------------------------------------------------------------
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzColorPickerModule } from 'ng-zorro-antd/color-picker';
import {
  IOzelAlan, OzelAlanTipi, OZEL_ALAN_TIPLERI, OZEL_ALAN_TIP_BILGI,
  ozelAlanTipiCoz, ozelAlanDegeriDonustur, ozelAlanOlustur,
} from './ozel-alan.types';

@Component({
  selector: 'ozel-alan-duzenleyici',
  standalone: true,
  imports: [
    CommonModule, FormsModule, NzInputModule, NzInputNumberModule, NzButtonModule,
    NzIconModule, NzSelectModule, NzDatePickerModule, NzSwitchModule, NzColorPickerModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="oad">
      <div class="oad-baslik">
        <span>{{ baslik() }}</span>
        <button nz-button nzSize="small" nzType="dashed" (click)="ekle()">
          <nz-icon nzType="plus"/> Alan Ekle
        </button>
      </div>

      <div class="oad-liste">
        @for (a of alanlar(); track $index) {
          <div class="oad-satir">
            <div class="oad-ust">
              <input nz-input nzSize="small" class="oad-ad"
                [ngModel]="a.ad"
                (ngModelChange)="adGuncelle($index, $event)"
                placeholder="Alan adı (Ör: Renk, Model, Ölçü)"/>

              <nz-select nzSize="small" class="oad-tip"
                [ngModel]="tip(a)"
                (ngModelChange)="tipGuncelle($index, $event)">
                @for (t of OZEL_ALAN_TIPLERI; track t) {
                  <nz-option [nzValue]="t" [nzLabel]="OZEL_ALAN_TIP_BILGI[t].etiket"/>
                }
              </nz-select>

              <button nz-button nzSize="small" nzDanger nzType="text" (click)="sil($index)" title="Alanı sil">
                <nz-icon nzType="delete"/>
              </button>
            </div>

            <div class="oad-deger">
              @switch (tip(a)) {
                @case ('metin') {
                  <input nz-input nzSize="small"
                    [ngModel]="a.deger"
                    (ngModelChange)="degerGuncelle($index, $event)"
                    placeholder="Değer"/>
                }
                @case ('coklu-metin') {
                  <textarea nz-input rows="2"
                    [ngModel]="a.deger"
                    (ngModelChange)="degerGuncelle($index, $event)"
                    placeholder="Değer"></textarea>
                }
                @case ('sayi') {
                  <nz-input-number nzSize="small" style="width:100%"
                    [ngModel]="a.deger"
                    (ngModelChange)="degerGuncelle($index, $event)"/>
                }
                @case ('tarih') {
                  <nz-date-picker nzSize="small" style="width:100%"
                    [ngModel]="tarihDegeri(a)"
                    (ngModelChange)="tarihGuncelle($index, $event)"/>
                }
                @case ('onay') {
                  <nz-switch nzSize="small"
                    [ngModel]="!!a.deger"
                    (ngModelChange)="degerGuncelle($index, $event)"/>
                  <span class="oad-onay-etiket">{{ a.deger ? 'Evet' : 'Hayır' }}</span>
                }
                @case ('secim') {
                  <div class="oad-secim">
                    <input nz-input nzSize="small"
                      [ngModel]="secenekMetni(a)"
                      (ngModelChange)="seceneklerGuncelle($index, $event)"
                      placeholder="Seçenekler (virgülle ayırın: Kırmızı, Mavi, Yeşil)"/>
                    @if ((a.secenekler ?? []).length) {
                      <nz-select nzSize="small" style="width:100%"
                        [ngModel]="a.deger"
                        (ngModelChange)="degerGuncelle($index, $event)"
                        nzPlaceHolder="Değer seçin">
                        @for (s of a.secenekler; track s) {
                          <nz-option [nzValue]="s" [nzLabel]="s"/>
                        }
                      </nz-select>
                    }
                  </div>
                }
                @case ('renk') {
                  <nz-color-picker
                    [ngModel]="a.deger || '#1677ff'"
                    (ngModelChange)="degerGuncelle($index, $event)"/>
                }
              }
            </div>
          </div>
        } @empty {
          <div class="oad-bos">
            Henüz özel alan eklenmedi. Ürüne/kayda özgü bilgiler (ölçü, renk, model, tarih vb.) ekleyebilirsiniz.
          </div>
        }
      </div>
    </div>
  `,
  styles: [`
    .oad { display:flex; flex-direction:column; gap:8px; }
    .oad-baslik { display:flex; align-items:center; justify-content:space-between;
      font-size:12px; font-weight:600; color:var(--py-metin,#333); }
    .oad-liste { display:flex; flex-direction:column; gap:8px; }
    .oad-satir { display:flex; flex-direction:column; gap:4px; padding:6px;
      border:1px solid var(--py-kenarlik,#e5e7eb); border-radius:8px; }
    .oad-ust { display:flex; gap:6px; align-items:center; }
    .oad-ad { flex:0 0 42%; }
    .oad-tip { flex:1; }
    .oad-deger { display:flex; align-items:center; gap:8px; }
    .oad-onay-etiket { font-size:12px; color:var(--py-metin-ikincil,#666); }
    .oad-secim { display:flex; flex-direction:column; gap:4px; width:100%; }
    .oad-bos { font-size:11px; color:var(--py-metin-ucuncul, rgba(0,0,0,.35)); padding:4px 0; }
  `],
})
export class OzelAlanDuzenleyiciComponent {
  /** Mevcut özel alan listesi (ebeveynden salt-okunur akış). */
  alanlar = input<IOzelAlan[]>([]);
  /** Bölüm başlığı; farklı ekranlarda özelleştirilebilir. */
  baslik = input<string>('🧩 Özel Alanlar');
  /** Her değişiklikte TAM yeni diziyi yayınlar; senkron/deep-clone yazma ebeveynin sorumluluğudur. */
  alanlarDegisti = output<IOzelAlan[]>();

  readonly OZEL_ALAN_TIPLERI = OZEL_ALAN_TIPLERI;
  readonly OZEL_ALAN_TIP_BILGI = OZEL_ALAN_TIP_BILGI;

  tip(a: IOzelAlan): OzelAlanTipi { return ozelAlanTipiCoz(a); }

  private yayinla(yeni: IOzelAlan[]) { this.alanlarDegisti.emit(yeni); }

  ekle() {
    this.yayinla([...this.alanlar(), ozelAlanOlustur('metin')]);
  }

  sil(i: number) {
    this.yayinla(this.alanlar().filter((_, idx) => idx !== i));
  }

  adGuncelle(i: number, ad: string) {
    this.yayinla(this.alanlar().map((a, idx) => idx === i ? { ...a, ad } : a));
  }

  degerGuncelle(i: number, deger: any) {
    this.yayinla(this.alanlar().map((a, idx) => idx === i ? { ...a, deger } : a));
  }

  tipGuncelle(i: number, yeniTip: OzelAlanTipi) {
    this.yayinla(this.alanlar().map((a, idx) => {
      if (idx !== i) return a;
      return {
        ...a,
        tip: yeniTip,
        deger: ozelAlanDegeriDonustur(a.deger, yeniTip),
        ...(yeniTip === 'secim' ? { secenekler: a.secenekler ?? [] } : {}),
      };
    }));
  }

  tarihDegeri(a: IOzelAlan): Date | null {
    if (!a.deger) return null;
    const d = new Date(a.deger);
    return isNaN(d.getTime()) ? null : d;
  }

  tarihGuncelle(i: number, deger: Date | null) {
    this.degerGuncelle(i, deger ? deger.toISOString() : null);
  }

  secenekMetni(a: IOzelAlan): string {
    return (a.secenekler ?? []).join(', ');
  }

  seceneklerGuncelle(i: number, metin: string) {
    const liste = metin.split(',').map(s => s.trim()).filter(Boolean);
    this.yayinla(this.alanlar().map((a, idx) => idx === i ? { ...a, secenekler: liste } : a));
  }
}
